import { render, staticRenderFns } from "./FacilitiesWidget.vue?vue&type=template&id=f1095a22"
import script from "./FacilitiesWidget.vue?vue&type=script&lang=js"
export * from "./FacilitiesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports